import React, { useState } from 'react';

const GoogleMap = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleLoad = () => {
    setIsLoading(false);
    setHasError(false);
  };

  const handleError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  return (
    <div className="relative h-0 w-full">
      {isLoading && (
        <div className="absolute left-0 top-0 flex h-40 w-full items-center justify-center rounded-md bg-gray-100">
          <div className="text-center">
            <div className="mb-2 h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-primary"></div>
            <span className="text-sm text-gray-600">Loading map...</span>
          </div>
        </div>
      )}
      {hasError && (
        <div className="absolute left-0 top-0 flex h-40 w-full items-center justify-center rounded-md bg-gray-100 p-4 text-center">
          <div>
            <p className="mb-2 text-gray-600">Unable to load map</p>
            <a
              href="https://www.google.com/maps"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-primary hover:underline"
            >
              View on Google Maps
            </a>
          </div>
        </div>
      )}
      <iframe
        className={`absolute left-0 top-0 h-40 w-full rounded-md transition-opacity duration-300 ${
          isLoading || hasError ? 'opacity-0' : 'opacity-100'
        }`}
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2398.6845979158747!2d-2.1864980223266146!3d53.04400559730114!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487a4366ba4bdb19%3A0xdb3c49206ff5f1f2!2sM%20B%20Autocare%20Garage!5e0!3m2!1sen!2suk!4v1733263777899!5m2!1sen!2suk"
        style={{ border: '0' }}
        loading="lazy"
        onLoad={handleLoad}
        onError={handleError}
      ></iframe>
    </div>
  );
};

export default GoogleMap;
